import TodoIcon from './TodoIcon';

export default TodoIcon;
export { TodoIcon };
